import { ActivityListItemDto } from '@/services/platform/api/model';
import { cn, useClientTranslation, useLocaleStore } from '@/lib/core';
import { formatActivityDate } from '@/lib/core/utils/dateTime';

function statusClass(status: string | null | undefined): string {
  if (!status) return 'text-[#b4870b]';
  return status.toUpperCase().startsWith('CANCEL') ? 'text-[#971b2f]' : 'text-[#b4870b]';
}

interface ActivityListCurrentProps {
  items: ActivityListItemDto[];
  trackMessage?: string | null;
  onItemClick?: (id: string) => void;
}

export function ActivityListCurrent({ items, trackMessage, onItemClick }: ActivityListCurrentProps) {
  const t = useClientTranslation();
  const locale = useLocaleStore(state => state.locale);
  return (
    <div className="flex flex-col gap-8 pb-[calc(((env(safe-area-inset-bottom)+1.5rem)*2)+48px)]">
      {trackMessage && (
        <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[14px] leading-normal tracking-[0.5px]">
          {trackMessage}
        </p>
      )}
      <div className="flex flex-col">
        {items.map(item => (
          <button
            key={item.id}
            type="button"
            className="border-jncquoi-neutral-200 flex flex-col gap-2 border-b-[0.5px] py-4 text-left first:pt-0!"
            onClick={() => item.id && onItemClick?.(item.id)}
          >
            {/* date · status */}
            <div className="flex items-center gap-2.5">
              <span className="font-pp-neue-montreal text-jncquoi-neutral-700 shrink-0 text-[10px] font-semibold tracking-[0.5px] whitespace-nowrap uppercase">
                {formatActivityDate(item.date, locale)}
              </span>
              {item.status && (
                <>
                  <span className="text-jncquoi-neutral-500 text-[8px] leading-none">●</span>
                  <span
                    className={cn(
                      'font-pp-neue-montreal shrink-0 text-[10px] font-semibold tracking-[0.5px] whitespace-nowrap uppercase',
                      statusClass(item.status)
                    )}
                  >
                    {item.status}
                  </span>
                </>
              )}
            </div>
            {/* order reference */}
            {item.id && (
              <span className="font-pp-neue-montreal text-jncquoi-neutral-700 text-[12px] tracking-[0.5px] whitespace-nowrap">
                {t('App.Labels.ActivityOrderId', { orderNumber: item.orderNumber })}
              </span>
            )}
            {/* items purchased */}
            {item.itemCount != null && item.itemCount > 0 && (
              <div className="flex flex-col gap-2">
                <span className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[12px] font-semibold tracking-[0.5px]">
                  {t('App.Labels.ActivityItemCount', { count: item.itemCount })}
                </span>
                {item.itemImages && item.itemImages.length > 0 && (
                  <div className="flex gap-2 overflow-x-auto overflow-y-clip">
                    {item.itemImages.map((src, i) => (
                      <div key={i} className="relative size-16 shrink-0 overflow-hidden">
                        <img
                          src={src}
                          alt=""
                          aria-hidden="true"
                          className="absolute inset-0 size-full max-w-none object-cover"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
